import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "btn [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "btn--purple",
        deep: "btn--deep",
        lilac: "btn--lilac",
        wa: "btn--wa",
        white: "btn--white",
        off: "",
        destructive: "btn--danger",
        outline: "btn--ghost",
        "outline-off": "btn--ghost-off",
        secondary: "btn--lilac",
        ghost: "btn--flat",
        link: "btn--flat underline underline-offset-4 px-1",
      },
      size: {
        default: "",
        sm: "btn--sm",
        xs: "btn--xs",
        lg: "text-lg",
        icon: "btn--flat h-10 w-10 p-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
